import {useRange} from "react-instantsearch-hooks-web";
import React, {useContext, useEffect, useState} from "react";
import FilterContext from "../../Context/FilterContext";

const DateRange = props => {
    const { minDate, maxDate } = props
    const { refine } = useRange(props);
    const { setLoading } = useContext(FilterContext)

    const [min, setMin] = useState(minDate)
    const [max, setMax] = useState(maxDate)

    const dateToTimestamp = date => {
        return new Date(date).getTime() / 1000
    }

    const onMinChange = event => {
        setMin(event.target.value)
    }

    const onMaxChange = event => {
        setMax(event.target.value)
    }

    useEffect(() => {
        const tmin = dateToTimestamp(min)
        const tmax = dateToTimestamp(max)

        if (setLoading) setLoading(true)

        refine([
            isFinite(tmin) ? tmin : undefined,
            isFinite(tmax) ? tmax : undefined
        ])
    }, [min, max])

    return (
        <div className={'flex gap-4 items-center justify-between'}>
            <input type="date" value={min} onChange={onMinChange} className={'flex-grow block rounded-md border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed focus:border-indigo-800 focus:ring focus:ring-indigo-800 focus:ring-opacity-25'}/>
            <span className={'flex-shrink-0'}>au</span>
            <input type="date" value={max} onChange={onMaxChange} className={'flex-grow block rounded-md border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed focus:border-indigo-800 focus:ring focus:ring-indigo-800 focus:ring-opacity-25'}/>
        </div>
    )
}

export default DateRange
